import { BaseEitherError } from '@uniqkey-frontend/shared-app';
import { SupportJumpAPIIncorrectAxiosInstanceError } from '../../common/errors';

export class SupportJumpGetPartnerKeysFetchError extends BaseEitherError {}

export type TSupportJumpGetPartnerKeysOperationErrors = SupportJumpGetPartnerKeysFetchError
  | SupportJumpAPIIncorrectAxiosInstanceError;
